import styled from "styled-components";
import {
  Button,
  LoadingBar,
  TypographyVariant,
} from "../../../../../../components/ui-kit";
import api from "../../../../../../util/api";
import { useEffect, useState } from "react";
import { Card, Label } from "../../shared/styles";
import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
const stripeInstance = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!
);

const Wrapper = styled.div`
  max-width: 1200px;
`;

const StyledLabel = styled(Label)`
  margin-top: 20px;
`;

const StyledCard = styled(Card)`
  padding: 30px 40px;
`;

const Content = styled.div`
  max-height: 90vh;
  overflow: auto;
`;

interface ModalProps {
  refresh: () => void;
}

const UpdatePaymentMethodModal: React.FunctionComponent<ModalProps> = ({
  refresh,
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [stripeCheckoutOptions, setStripeCheckoutOptions] = useState<any>(null);
  const [error, setError] = useState<boolean>(false);

  const _fetchCheckoutSession = async () => {
    try {
      // GET checkout session
      const response = await api.getStripeUpdatePaymentMethodCheckout();
      if (response?.result?.client_secret) {
        const clientSecret = response.result.client_secret;
        setStripeCheckoutOptions({ clientSecret });
        setLoading(false);
        return clientSecret;
      }

      return response;
    } catch (error) {
      console.error("ERROR", error);
      setError(true);
    }
  };

  useEffect(() => {
    _fetchCheckoutSession();
  }, []);

  const handleRetry = async () => {
    setError(false);
    setLoading(true);
    _fetchCheckoutSession();
  };
  return (
    <Wrapper>
      <Content>
        <StyledCard style={{ minHeight: 900, margin: 50 }}>
          <>
            <StyledLabel
              style={{ marginBottom: 50, maxWidth: 600, textAlign: "center" }}
              variant={TypographyVariant.HEADER1}
            >
              {!loading
                ? error
                  ? "Checkout failed. Please try again."
                  : "Please fill in all the information in order to complete the process for payment method update"
                : "Loading payment method update checkout..."}
            </StyledLabel>
            {!loading ? (
              <div id="checkout">
                <EmbeddedCheckoutProvider
                  stripe={stripeInstance}
                  options={stripeCheckoutOptions}
                >
                  <EmbeddedCheckout />
                </EmbeddedCheckoutProvider>
              </div>
            ) : (
              <LoadingBar loading={loading} margin="50px 0" />
            )}
            {error && (
              <>
                <center>
                  <Button onClick={handleRetry}>Retry</Button>
                </center>
              </>
            )}
          </>
        </StyledCard>
      </Content>
    </Wrapper>
  );
};

export default UpdatePaymentMethodModal;
